import { PrimaryButton } from '@/lib';

// Asset step is intentionally minimal: the gateway proxies asset
// writes to asset-service via the write-forwarder, so a real POST
// here would need a separate hook + the downstream service running.
// For now the wizard lets the user acknowledge the step manually so
// they can keep moving; the asset.created counter hook lands in a
// follow-up alongside the proxy-tap.
export function AssetStep({ onCompleted }: { onCompleted: () => void }) {
  return (
    <div className="flex flex-col gap-sp-4">
      <p className="text-fs-body text-gray-700">
        Add the assets you want to monitor. You can do this from the
        Fleet view too; for the wizard, just confirm you've created at
        least one asset.
      </p>
      <p className="text-fs-meta text-gray-700">
        Going to{' '}
        <a className="text-info hover:underline" href="/fleet">
          /fleet
        </a>
        {' '}is a quick way to see your existing assets.
      </p>
      <PrimaryButton label="I've added my assets" onClick={onCompleted} />
    </div>
  );
}
